"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionDrawDTO = void 0;
class TicketSubmissionDrawDTO {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.drawNumber = data.drawNumber;
        this.draw = data.draw;
        this.shortName = data.shortName;
        this.playerConfirmationRequired = data.playerConfirmationRequired;
        this.optInMessage = data.optInMessage;
        this.optOutMessage = data.optOutMessage;
        this.optOutDuration = data.optOutDuration;
        this.defaultDrawAction = data.defaultDrawAction;
    }
}
exports.TicketSubmissionDrawDTO = TicketSubmissionDrawDTO;
//# sourceMappingURL=TicketSubmissionDrawDTO.js.map